import PropTypes from 'prop-types'
import { Component } from 'react'
import getRoutePath from '../../utils/getRoutePath'

import template from './template.rt'
import './styles.css'

export const parseSubscriberAction = action => {
  if (typeof action === 'string' && /tutorials\/.*\/watch/.test(action)) {
    const routePath = getRoutePath(window.location.href)
    if (/\?.*=.*/.test(action)) return `${action}&referer=${routePath}`
    return `${action}?referer=${routePath}`
  }
  return action
}

export class FeaturedElement extends Component {
  render() {
    return template.call(this)
  }
}

export const FeaturedElementStructure = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  photo: PropTypes.objectOf(PropTypes.string).isRequired,
  onClick: PropTypes.func,
  btn: PropTypes.shape({
    text: PropTypes.string,
    action: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    class: PropTypes.string
  }),
  categoryName: PropTypes.string,
  categoryLinkTo: PropTypes.string,
  isMobile: PropTypes.bool,
  usedFreeTrial: PropTypes.bool
}

FeaturedElement.propTypes = FeaturedElementStructure

FeaturedElement.defaultProps = {
  btn: {},
  category: null,
  categoryLinkTo: '',
  categoryName: '',
  description: '',
  isMobile: false,
  linkTo: '',
  onClick: null,
  usedFreeTrial: false,
  videoAction: null
}

export default FeaturedElement
